import type { OWAConnectedAccount } from "./schema/OWAConnectedAccount";
import type { AccountKey } from "owa-client-types";
import { createStore } from "owa-satcheljs";
import { AccountsStoreState } from "./schema/AccountsStoreState";

export interface AccountStore {
    accountsMap: Map<AccountKey, OWAConnectedAccount>;
    accountsLoadedState: AccountsStoreState;
}

const defaultExport: () => AccountStore = createStore("OWAAccountsStore", {
    accountsMap: new Map<AccountKey, OWAConnectedAccount>([]),
    accountsLoadedState: AccountsStoreState.None,
});
export default defaultExport;
